import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Role } from '../models/role.enum';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const requiredRoles = route.data['roles'] as Role[] | undefined;
  const requiredPermission = route.data['permission'] as string | undefined;

  if (requiredRoles && !auth.hasAnyRole(...requiredRoles)) {
    return router.createUrlTree(['/dashboard']);
  }

  if (requiredPermission && !auth.hasPermission(requiredPermission)) {
    return router.createUrlTree(['/dashboard']);
  }

  return true;
};
